module.exports = __webpack_public_path__ + "static/media/Pres_3.f93a3f2c.jpg";